"use client";
import * as React from "react";
const SvgShoppingCartSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M12.367 12.8c-.85 0-1.538.72-1.538 1.6 0 .88.688 1.6 1.538 1.6.85 0 1.546-.72 1.546-1.6 0-.88-.696-1.6-1.546-1.6Zm-7.73 0c-.85 0-1.537.72-1.537 1.6 0 .88.687 1.6 1.538 1.6.85 0 1.546-.72 1.546-1.6 0-.88-.696-1.6-1.546-1.6Zm0-2.4.85-1.6h5.76c.58 0 1.09-.328 1.352-.824L16 1.6H3.254L2.528 0H0v1.6h1.546l2.782 6.072L2.026 12h11.888v-1.6H4.638Z" }));
export {
  SvgShoppingCartSharp as default
};
